import {FormProps} from "../../core/form/formUtils";
import {VatRate} from "../domain/invoiceDomain";
import {observer} from "mobx-react";
import React from "react";
import {DefinitionType} from "../../core/form/form";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {createForm} from "../../core/form/createForm";

export const  VatRateFormDefinition : DefinitionType = {
  formName : "VatRateForm",
  fields : [
    {
      name : "name",
      validators: ['IsRequired']
    },
    {
      name : "validFrom",
      validators: ['IsRequired']
    },
    {
      name : "validTo",
      validators: ['IsRequired']
    },
    {
      name : "vatRateCountry",
      validators: ['IsRequired']
    },
    {
      name : "noVat",
      validators: ['IsRequired']
    }
  ]
}

@observer
class VatRateForm extends React.Component<FormProps<VatRate, VatRate>, undefined> {
  render() {
    return (
      <noscript/>
    )
  }

}

export const VatRateClosedContent = ({dataObject, entity, entities, fields}: ClosedFormBlockProps<VatRate>) => (
  <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
    <ClosedFormField label={fields.name.textLabel} value={dataObject.name}/>
    <ClosedFormField label={fields.validFrom.textLabel} value={dataObject.validFrom}/>
    <ClosedFormField label={fields.validTo.textLabel} value={dataObject.validTo}/>
    <ClosedFormField label={fields.vatRateCountry.textLabel} value={dataObject.vatRateCountry}/>
    <ClosedFormField label={fields.noVat.textLabel} value={dataObject.noVat ? "TRUE" : "FALSE"}/>
  </ClosedFormBlock>

)

export default createForm(VatRateFormDefinition, VatRateClosedContent)(VatRateForm);



// WEBPACK FOOTER //
// ./src/invoice/component/vatRateForm.tsx